import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { SegmentationContextMenuItem } from '../../components/SegmentationContextMenuItem';
import { ISegmentationOrderBl } from '../../segmentationsOrder.Bl';

interface IProps {
  onMenuClose(): void;
  segmentationId: string;
}

export const SendToBackContextMenuItemContainer = observer((props: IProps): ReactElement => {
  const segmentationOrderBl = useInjection(ISegmentationOrderBl.$);

  const handleAction = (): void => {
    segmentationOrderBl.sendSegmentationToBack(props.segmentationId);
  };

  return (
    <SegmentationContextMenuItem
      {...props}
      text='send_to_back'
      icon='send-back-icon'
      action={handleAction}
    />
  );
});
